import React from 'react';
import { useInView } from 'react-intersection-observer';
import { CheckCircle2 } from 'lucide-react';

const benefits = [
  'Reduce HAZOP study duration by up to 40%',
  'Eliminate manual documentation and report generation',
  'Enable seamless remote team collaboration',
  'Ensure compliance with industry standards',
  'Track and manage action items effectively',
  'Access your studies from anywhere, anytime'
];

export default function Benefits() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <img 
              src="./transform.png"
              alt="Digital HAZOP Benefits"
              className="rounded-xl shadow-2xl w-96"
            />
          </div>
          
          <div className="lg:w-1/2">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Transform Your Safety Studies
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Our digital platform revolutionizes how teams conduct HAZOP studies,
              bringing efficiency and precision to every step of the process.
            </p>
            
            <div 
              ref={ref}
              className="grid gap-4"
            >
              {benefits.map((benefit, index) => (
                <div 
                  key={index}
                  className={`flex items-center gap-3 transform transition-all duration-500 ${
                    inView 
                      ? 'translate-x-0 opacity-100' 
                      : 'translate-x-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" />
                  <span className="text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}